const CUSTOM_GRID_COUNTRIES = ['US', 'CN', 'JP'];

const hasCustomLayout = (country: string) => CUSTOM_GRID_COUNTRIES.includes(country);

export const gridModifier = ( isCheckoutLayout = false, country: string ) => {
    if (isCheckoutLayout) {
        let baseClassName = 'isCheckoutLayout';

        if (hasCustomLayout(country)) {
            baseClassName += ` grid--${country}`;
        } else {
            baseClassName += ' grid';
        }

        return baseClassName;
    }

    return undefined;
};
